import React from 'react';
import { ArrowUp, ArrowDown, ChevronsUpDown } from 'lucide-react';

export default function SortableHeader({ label, col, sortKey, sortDir, onSort, className = '', right = false }) {
  const active = sortKey === col;
  return (
    <th
      className={`px-4 py-3 text-sm font-medium text-gray-600 cursor-pointer select-none hover:bg-gray-100 transition-colors group ${right ? 'text-right' : 'text-left'} ${className}`}
      onClick={() => onSort(col)}
    >
      <span className={`inline-flex items-center gap-1 ${right ? 'justify-end w-full' : ''}`}>
        {label}
        {active
          ? (sortDir === 'asc' ? <ArrowUp size={13} className="text-primary-600 flex-shrink-0" /> : <ArrowDown size={13} className="text-primary-600 flex-shrink-0" />)
          : <ChevronsUpDown size={13} className="text-gray-300 group-hover:text-gray-400 flex-shrink-0" />
        }
      </span>
    </th>
  );
}
